import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ICellRendererParams } from 'ag-grid-community';
import minusSvg from 'assets/icons/minus.svg';
import plusSvg from 'assets/icons/plus.svg';
import Button, { Color, Size } from 'lib/Button';

export const CampaignCellRenderer = (params: ICellRendererParams): JSX.Element => {
  const { node, api } = params;
  const [isRowExpanded, setIsRowExpanded] = useState(node.expanded);

  const toggleExpandCollapseRow = (): void => {
    api.setRowNodeExpanded(node, !isRowExpanded);
    setIsRowExpanded((prevState) => !prevState);
  };

  return (
    <div className="flex items-center gap-3 w-full" data-test-id="group-cell-renderer">
      <Button
        onClick={toggleExpandCollapseRow}
        svg={isRowExpanded ? minusSvg : plusSvg}
        color={Color.GREY}
        size={Size.SMALL}
        dataTestId="group-cell-expand-button"
        classNames="!rounded-[50%]"
      />
      <span className="sub-header-base min-w-0 truncate">
        {node.data.campaignName || node.data.userVisibleId || node.data.campaignId}
      </span>
      <Link
        to={`/planner/direct-sales/${node.data.campaignId}`}
        target="_blank"
        rel="noopener noreferrer"
        className="ml-auto flex-shrink-0 body-sm text-primary-600 hover:underline"
        title="Open campaign in new tab"
      >
        {node.data.userVisibleId || node.data.campaignId}
      </Link>
    </div>
  );
};
